<template>
  <div id="app">
	    <router-view />
  </div>
</template>

<script>
export default {
  name: "app"
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss">
@import "~@/assets/style/public-class.scss";
</style>
